import { SettingsForm } from './SettingsForm'
import { KioskDevicesCard } from './KioskDevicesCard'
import { useSettings } from './useSettings'

/** Einstellungen: lädt den Settings-Stand und übergibt ihn an das Formular (Werkstatt + §14-Firmendaten). */
export function SettingsPage() {
  const { data, isLoading, error } = useSettings()

  return (
    <section className="wf-view">
      <div>
        <h2 className="viewtitle">Werkstatt-Profil</h2>
        <p className="sub">Werkstatt &amp; §14-Firmendaten für die Rechnung</p>
      </div>
      {isLoading ? (
        <div className="muted">Einstellungen werden geladen…</div>
      ) : error || !data ? (
        <div className="error" role="alert">
          Einstellungen konnten nicht geladen werden.
        </div>
      ) : (
        <>
          <SettingsForm initial={data} />
          <KioskDevicesCard />
        </>
      )}
    </section>
  )
}
